<template>
    <div class="flex flex-col w-full h-full justify-center content-center">
        <h1 class=" text-3xl text-gray-800 dark:text-gray-50 font-bold">Fax. Get Spittin'</h1>
        <h1 class=" text-gray-500 text-sm xs:text-lg md:text-2xl">The only fans account your parents will be proud of</h1>
    </div>
</template>